var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_30021_208552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_30021_208552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0517 68.3335V59.526L65.1475 41.5126C65.5619 41.1198 66.0094 40.8337 66.49 40.6543C66.9706 40.4748 67.4511 40.3851 67.9317 40.3851C68.4556 40.3851 68.9625 40.4832 69.4525 40.6793C69.9425 40.8759 70.3878 41.1709 70.7883 41.5643L73.8717 44.6793C74.265 45.0943 74.5514 45.5432 74.7308 46.0259C74.9103 46.5087 75 46.9915 75 47.4743C75 47.9571 74.9017 48.4485 74.705 48.9484C74.5083 49.4484 74.2133 49.9057 73.82 50.3201L55.8592 68.3335H47.0517ZM15 64.3593V58.0318C15 56.2412 15.4744 54.6815 16.4233 53.3526C17.3722 52.0237 18.605 51.0023 20.1217 50.2884C23.6306 48.729 27.0131 47.5537 30.2692 46.7626C33.5258 45.9721 36.7694 45.5768 40 45.5768C41.8117 45.5768 43.6172 45.7115 45.4167 45.9809C47.2156 46.2504 49.0425 46.6371 50.8975 47.141L40.9617 56.9618V64.3593H15ZM67.9425 50.6926L71.0258 47.4743L67.9425 44.3593L64.7758 47.5259L67.9425 50.6926ZM40 38.9235C36.9156 38.9235 34.3017 37.8515 32.1583 35.7076C30.0144 33.5637 28.9425 30.9498 28.9425 27.866C28.9425 24.7815 30.0144 22.1673 32.1583 20.0235C34.3017 17.8796 36.9156 16.8076 40 16.8076C43.0844 16.8076 45.6983 17.8796 47.8417 20.0235C49.9856 22.1673 51.0575 24.7815 51.0575 27.866C51.0575 30.9498 49.9856 33.5637 47.8417 35.7076C45.6983 37.8515 43.0844 38.9235 40 38.9235Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonEdit);
export default __webpack_public_path__ + "static/media/person_edit.8875515f5d28f9e8424f1f96b3b5584f.svg";
export { ForwardRef as ReactComponent };